module.exports = __webpack_public_path__ + "img/svg/explain-2.ebd611507d067f432cfa6cbd23268903.svg";